module.exports = __webpack_public_path__ + "static/media/button@2x.b09369a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/my-gift/button@2x.png
// module id = 518
// module chunks = 1